// Judge.me's storefront widgets can render English copy despite the Dutch locale.
// Keep the live rating and review count from the app; only localize its labels.
// On the homepage Judge.me only loads after the first interaction (Performance
// Guard in layout/theme.liquid), so the observer starts then and runs at most
// once per 250 ms. The previous version observed the whole body from
// DOMContentLoaded and ran three document-wide queries on every mutation for
// 5 s: a 190 ms long task on mobile during load (ronde 50).
(function () {
  const localize = () => {
    document.querySelectorAll('.jdgm-all-reviews-text__text').forEach((element) => {
      const rating = Number(element.dataset.shopRating || element.dataset.score);
      const count = Number(element.dataset.numberOfReviews);
      if (!Number.isFinite(rating) || !Number.isFinite(count) || count < 1) return;
      const text = `Klanten geven ons ${rating.toLocaleString('nl-NL', { maximumFractionDigits: 1 })}/5 op basis van ${count} beoordelingen.`;
      if (element.textContent.trim() !== text) element.textContent = text;
    });
    document.querySelectorAll('.jdgm-carousel-title').forEach((element) => {
      if (element.textContent.trim() === 'Let customers speak for us') element.textContent = 'Dit zeggen klanten';
    });
    document.querySelectorAll('.jdgm-carousel-number-of-reviews').forEach((element) => {
      const count = Number(element.dataset.numberOfReviews);
      if (!Number.isFinite(count) || count < 1) return;
      const text = `${count} beoordelingen`;
      if (element.textContent.trim() !== text) element.textContent = text;
    });
  };

  const watch = () => {
    let pending = false;
    const observer = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      window.setTimeout(() => { pending = false; localize(); }, 250);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 8000);
  };

  const events = ['pointerdown', 'touchstart', 'keydown', 'mousemove', 'wheel'];
  const onInteraction = () => {
    events.forEach((name) => window.removeEventListener(name, onInteraction, { passive: true }));
    watch();
  };

  const start = () => {
    localize();
    events.forEach((name) => window.addEventListener(name, onInteraction, { passive: true }));
  };

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
